import React from 'react';
import { useTranslation } from 'react-i18next';
import {Accordion} from '../../Components/index';

function WhyUsAcc() {
    const { t, i18n } = useTranslation();
      
        const questions = [
            { title: t('quastionAccWhy'),  content: t('quastionAns1') },
            { title: t('quastionAccWhy2'),  content: t('quastionAns2') },
            { title: t('quastionAccWhy3'),  content: t('quastionAns3') },
            { title: t('quastionAccWhy4'),  content: t('quastionAns4') }
          ];
  return (
    <>
    <div className="accordion-container">
                <h3>{t('quastionWhyUs')}</h3>
                {questions.map((item, index) => (
                  <Accordion key={index} title={item.title} content={item.content} />
                ))}
              </div>
    </>
  )
}

export default WhyUsAcc;